import { useCallback, useMemo } from 'react';
import { logEvent, logScreenView, logButtonClick, setUserId as setUserIdFirebase, getCurrentUserId, clearUserId as clearUserIdFirebase, waitForAnalytics } from '../../services/firebase/analytics';

export const useAnalytics = () => {
  // Track a custom event
  const trackEvent = useCallback(async (eventName, eventParams = {}) => {
    await waitForAnalytics();
    logEvent(eventName, eventParams);
  }, []);

  // Track a screen view
  const trackScreenView = useCallback(async (eventName, additionalParams = {}) => {
    await waitForAnalytics();
    logScreenView(eventName, additionalParams);
  }, []);

  // Track a button click
  const trackButtonClick = useCallback(async (eventName, buttonName, additionalParams = {}) => {
    await waitForAnalytics();
    logButtonClick(eventName, buttonName, additionalParams);
  }, []);

  // Set user ID
  const setAnalyticsUserId = useCallback(async (userId) => {
    await waitForAnalytics();
    setUserIdFirebase(userId);
  }, []);

  // Get current user ID
  const getAnalyticsUserId = useCallback(() => {
    return getCurrentUserId();
  }, []);

  // Clear user ID
  const clearAnalyticsUserId = useCallback(async () => {
    await waitForAnalytics();
    clearUserIdFirebase();
  }, []);

  // 各関数はuseCallback([])で参照が安定しているため、
  // このオブジェクト自体もuseMemoで安定させることで、
  // useEffectの依存配列に含めても不要な再発火が起きないようにする
  return useMemo(() => ({
    trackEvent,
    trackScreenView,
    trackButtonClick,
    setAnalyticsUserId,
    getAnalyticsUserId,
    clearAnalyticsUserId,
  }), [trackEvent, trackScreenView, trackButtonClick, setAnalyticsUserId, getAnalyticsUserId, clearAnalyticsUserId]);
};
